///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace - abcsetup.datatables.client_side
//
//  Used to datatables completely client-side using existing table markup
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = abcsetup.datatables || {};
abcsetup.datatables.client_side = abcsetup.datatables.client_side || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables.client_side = {
    /**
     * Build the datatable
     */
    init: function (table, options = null) {
        // Destroy the datatable if we have one already
        this.reset(table, false);

        if (!options['dom']) {
            options['dom'] = 'ltipB';
        }

        if (!options['searchable']) {
            options['searchable'] = false;
        }

        // Apply the column filtering
        if (options["searchable"]) {
            // We have column searching parameters specified ------------------------------------------
            options['searchCols'] = [];
            var searchColParam = abcsetup.getUrlParameter('search_cols[]');
            var searchColVals = abcsetup.getUrlParameter('search_vals[]');

            // Format columns into an array
            var columns = [];
            table.find('th').each(function () {
                columns.push({'name': $(this).text().toLowerCase().replace('\'', '_').replace(/ /g, '_')});
            });

            columns = options['columns'] ? options['columns'] : columns;

            if (searchColParam) {
                $(columns).each(function (i) {
                    var idx = searchColParam.indexOf(this.name);

                    if (idx == -1) {
                        options['searchCols'].push(null);
                    } else {
                        options['searchCols'].push({'sSearch': searchColVals[idx]});
                    }
                });
            }
            options['columns'] = columns;
            // ----------------------------------------------------------------------------------------
        }

        table.show().css('width', '100%');
        var _return = table.DataTable(options);

        // Move the export buttons
        abcsetup.datatables.buttons.init(table, options);

        // Apply the column filtering
        if (options["searchable"]) {
            abcsetup.datatables.search.init(table);
        }

        return _return;
    },


    /**
     * Destory the datatable if we have one already
     */
    reset: function (table, killVals = true) {
        //if (table.DataTable() instanceof $.fn.dataTable.Api) {
        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().colReorder.reset();
            table.DataTable().destroy();
        }

        table.find('.datatable-filter-btn').remove();
        table.hide();

        if (killVals) {
            table.find('tbody tr').remove();
        }
    },
}
